import { Chip, Grid, Stack, Tooltip, Typography } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import * as React from 'react';
import * as Redux from 'react-redux';
import styled from 'styled-components';
import * as CONST from '../../../../constants/FieldsConst';
import { textLabels } from '../../../../helpers';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import ActionsListWidget from '../../../../widgets/ActionsList';
import DeleteModalComponent from '../../../../widgets/modals/DeleteModal';
import { NameComponent } from '../../../usuario/usuarios/components/ListadoUsuarios';
import { rolesArray } from '../../../usuario/usuarios/components/SelectFieldRoles';
import {
  allPerfilesAction,
  deletePerfilesAction,
  setActivoPerfilesAction,
} from '../PerfilesAction';

export const Links = styled.a`
  cursor: pointer;
  color: black;
  margin: 0px 0px;
  text-decoration: none;

  &:hover {
    color: blue;
  }
`;

const ListadoPerfiles = () => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const loginStore = Redux.useSelector((state) => state.login);
  const perfilesStore = Redux.useSelector((state) => state.perfiles);

  const [loadingDelete, setLoadingDelete] = React.useState(false);
  const [openModalDelete, setOpenModalDelete] = React.useState(false);

  React.useEffect(() => {
    const fetchData = async () => {
      if (perfilesStore.all && perfilesStore.all.length === 0) {
        await allPerfilesAction(dispatch, null);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handleEditClick = async (id) => {
    const data = perfilesStore.all.find((el) => el.id === id);
    await setActivoPerfilesAction(dispatch, data);
  };

  const _onDeleteHandler = async () => {
    setLoadingDelete(true);
    await deletePerfilesAction(
      { dispatch, notify },
      perfilesStore.activo.id,
      perfilesStore.params,
    );
    setLoadingDelete(false);
    setOpenModalDelete(false);
  };

  const columns = [
    {
      name: CONST.ID,
      options: {
        display: loginStore.isRoot ? false : 'excluded',
        filter: false,
      },
    },
    {
      name: CONST.nombre.name,
      label: CONST.nombre.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <NameComponent
                onClick={() => _handleEditClick(tableMeta.rowData[0])}
                mr="1em"
              >
                {value}
              </NameComponent>
              {perfilesStore.activo?.id === tableMeta.rowData[0] && (
                <Chip label="Editando" size="small" color="info" />
              )}
            </Stack>
          );
        },
      },
    },
    {
      name: CONST.rol.name,
      label: CONST.rol.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Typography variant="body1" color="initial">
              {rolesArray[value]}
            </Typography>
          );
        },
      },
    },
    {
      name: CONST.totalUsuarios.name,
      label: CONST.totalUsuarios.label,
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: CONST.estatus.name,
      label: CONST.estatus.label,
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Tooltip
              describeChild
              title="Estatus del registro"
              placement="left"
            >
              <Chip
                label={value?.nombre ?? '-'}
                size="small"
                color={value?.id === 1 ? 'success' : 'error'}
              />
            </Tooltip>
          );
        },
      },
    },
    {
      name: CONST.actions.name,
      label: CONST.actions.label,
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <Stack direction="row">
              <ActionsListWidget
                id={tableMeta.rowData[0]}
                onEdit={() => _handleEditClick(tableMeta.rowData[0])}
                onDelete={async () => {
                  const data = perfilesStore.all.find(
                    (el) => el.id === tableMeta.rowData[0],
                  );
                  await setActivoPerfilesAction(dispatch, data);
                  setOpenModalDelete(true);
                }}
              />
            </Stack>
          );
        },
      },
    },
  ];

  const options = {
    filterType: 'dropdown',
    setTableProps: () => {
      return {
        padding: 'none',
        size: 'small',
      };
    },
    rowsPerPage: 25,
    rowsPerPageOptions: [25, 50, 100],
    print: false,
    textLabels,
    selectableRowsHideCheckboxes: true,
    expandableRows: true,
    renderExpandableRow: (rowData, rowMeta) => {
      return <Grid container></Grid>;
    },
  };

  return (
    <Grid container>
      <Grid item md={12}>
        <LoadingWidget isLoading={perfilesStore.loadingAll || loadingDelete} />
        <MUIDataTable
          title={'Listado'}
          data={perfilesStore.all}
          columns={columns}
          options={options}
        />
      </Grid>
      {perfilesStore.activo && (
        <DeleteModalComponent
          open={openModalDelete}
          onClose={() => setOpenModalDelete(!openModalDelete)}
          onDelete={_onDeleteHandler}
        >
          <Typography variant="h6">{perfilesStore.activo.nombre}</Typography>
        </DeleteModalComponent>
      )}
    </Grid>
  );
};

export default ListadoPerfiles;
